export default {
    heading: "变更登入二维码",
    desc: "贵校如已选用教城简易登入服务，您即可无须输入密码登入教城网页。您亦可以在此检视登入二维码或刷新二维码作登入教城之用。",
    createdAt: "刷新日",
    expireAt: "到期日",
    lostQrcode: "刷新/遗失二维码",
    downloadQrcode: "下载登入二维码",
    printQrcode: "列印登入二维码",
    confirmRegenContent: "确定刷新登入二维码?",
    confirm: "确定",
    cancel: "取消",
    noQrcodeDesc: "贵校如已选用教城简易登入服务，您即可无须输入密码登入教城网页。您亦可以在此检视登入二维码或刷新二维码作登入教城之用。",
    noQrcode: "登入二维码无效，请联络学校管理员刷新登入二维码。",
}
